'use client';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import Button from '@repo/ui/src/components/Button';
import ProductPrice from '@components/Product/Price';
import buildLinkObj from '@repo/ui/src/functions/build-link';
import { logProduct } from '@utils/productWrapper';
import { Anchor } from '@repo/ui/src/components/Anchor';
import GrillCapacity from '../GrillCapacityAndMeasurement/_GrillCapacity';

interface Props {
  buttonLabel: string;
  buttonText: string;
  product: any;
  index: number;
}

const GrillFeatureComparisonItem = ({ buttonLabel, buttonText, product, index }: Props) => {
  const { locale } = useCurrentUrl();

  if (!product?.data?.productCapacityInfo) return null;
  const extendedLabel = `${buttonLabel}: ${product.shortTitle}`;
  const closedImage = product?.data?.frontFacingImages?.closedImage;
  const closedImgUrl = closedImage?.image ? buildImageSrc(closedImage, 600, 1, 1) : null;

  return (
    <div
      className="tw-flex tw-flex-col tw-justify-center tw-items-stretch tw-text-center tw-flex-1 tw-relative tw-z-10"
      role="group"
      aria-label="product"
    >
      <a
        href={buildLinkObj({ link: product.deliveryKey })?.href}
        aria-label={product.title}
        className="tw-relative -tw-mb-[25%] tw-pb-[100%] -tw-z-10 tw-transform tw-duration-500 md:-tw-mb-[45%] hover:md:-tw-translate-y-3"
      >
        {closedImgUrl && (
          <LazyLoadImage
            imgComponent={
              <img
                src={closedImgUrl}
                alt={closedImage.image.name}
                className="tw-image tw-absolute tw-w-[90%] tw-h-[90%] tw-left-[5%] sm:tw-w-[70%] sm:tw-h-[70%] tw-left-[15%]"
              />
            }
          />
        )}
      </a>
      <h2 className="tra-text-web-heading-2 tw-self-center tw-w-full tw-bg-neutral-700 tw-text-warm-100 tw-p-6 [&_span]:tw-text-brand-300">
        {product.shortTitleMain ? (
          <>
            {product.shortTitleMain} <span>{product.shortTitlePrimary}</span>
          </>
        ) : (
          <>{product.title}</>
        )}
      </h2>
      <div className="tw-bg-white tw-flex-grow-1 tw-py-10 tw-px-6 md:tw-py-11 md:tw-px-10">
        <h4 className="tra-text-web-heading-4">
          {product.data.productCapacityInfo?.grillFeatureLabels?.capacity}
        </h4>
        <GrillCapacity {...product.data.productCapacityInfo} />
        <ProductPrice product={product} align="center" variant="h5" component="p" gutterBottom />
        <div className="tw-flex tw-justify-center">
          <Button
            link={product.deliveryKey}
            label={extendedLabel}
            as={Anchor}
            onClick={() => {
              logProduct('PRODUCT_CLICKED', {
                product: product,
                list_name: 'Grill Feature Comparison',
                locale,
                position: index,
                coupon_name: product?.data?.promotionId,
              });
            }}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GrillFeatureComparisonItem;
